/**
 * Sidebar RMA Status section: tab-relevant status chips that update draft filter_status only
 */
import { observer } from "mobx-react";
import "./rma-list-quick-filters-tabs.scss";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import RmaListFiltersStore from "../../../rma-list-page/stores/rma-list-filters-store";
import FontBody2 from "../../../../../components/fonts/font-body2/font-body2";
import { FONT_VARIANT } from "../../../../../components/fonts/font-props";
import RmaListStatusFilterChip from "../rma-list-status-filter-chip/rma-list-status-filter-chip";

interface IProps {
    rmaListFiltersStore: RmaListFiltersStore;
    disabled: boolean;
}

const RmaListQuickFiltersTabs: React.FC<IProps> = observer(({ rmaListFiltersStore, disabled }) => {
    const { getTranslation } = useDashboardTranslation();
    const translate = (key: string) => getTranslation(key, "dashboard-returns-page");
    const scope = "dashboard-returns-page";
    const statuses = rmaListFiltersStore.getVisibleQuickFilterStatuses(translate);

    return (
        <div className="rma-list-quick-filters-tabs">
            <FontBody2 variant={FONT_VARIANT.BOLD}>
                {getTranslation("FILTERS_RMA_STATUS", scope)}
            </FontBody2>
            <div className="rma-list-quick-filters-tabs__chips">
                {statuses.map((status) => (
                    <RmaListStatusFilterChip
                        key={status.id}
                        title={status.title}
                        disabled={disabled}
                        isSelected={rmaListFiltersStore.selectedQuickFilter === status.id}
                        onClick={() => rmaListFiltersStore.toggleSelectedQuickFilter(status.id)}
                    />
                ))}
            </div>
        </div>
    );
});

export default RmaListQuickFiltersTabs;
